module.exports = __webpack_public_path__ + "static/media/gbuffer.e9d7411c.frag";